export default "__VITE_ASSET__dJp3tGnt__"